import { type FC } from "react";

import { cx } from "@emotion/css";
import { Button } from "@snapchat/snap-design-system";

import { Flexbox } from "../../../shared/components";
import { buttonDisabled } from "../../../shared/styles";

export const LensCtaFormFooter: FC<{
    onCancel: () => void;
    onSave: () => void;
    isDisabled: boolean;
}> = ({ onCancel, onSave, isDisabled }) => {
    return (
        <Flexbox justifyContent="flex-end">
            <Button onClick={onCancel} isDisabled={false}>
                Cancel
            </Button>
            <Button
                type="primary"
                onClick={onSave}
                isPending={false}
                className={cx(isDisabled && buttonDisabled)}
                aria-disabled={isDisabled}
            >
                Save
            </Button>
        </Flexbox>
    );
};
